module.exports = __webpack_public_path__ + "static/media/CSS3_Badge.3d5faf5c.png";